import TableList from 'components/commons/TableList/TableList.component';
import { Stack } from 'styles';
import { ComplaintTrackingBody } from './ComplaintTrackingBody.component';
import ComplaintTrackingHeader from './ComplaintTrackingHeader.component';

const ComplaintTrackingTable = () => {
	return (
		<Stack width={'100%'} height={`calc(100vh - 280px)`} overflow={'hidden'}>
			<TableList header={<ComplaintTrackingHeader />} body={<ComplaintTrackingBody />} />
		</Stack>
	);
};

export default ComplaintTrackingTable;
